// utils
import { generateRandomCode } from 'app/utils';

function initiatePrescriptionStep(prescriptions) {
  // const { medicaments = [], diets = [], procedures = [] } = prescriptions;

  const callback = prescriptionItem => {
    const { formAddOn } = prescriptionItem;

    return {
      ...prescriptionItem,
      formAddOn: {
        ...formAddOn,
        randomCode: generateRandomCode()
      }
    };
  };

  const medicaments = prescriptions.medicaments.map(callback);
  const diets = prescriptions.diets.map(callback);
  const procedures = prescriptions.procedures.map(callback);

  const prescriptionStep = {
    medicaments,
    diets,
    procedures
  };

  return prescriptionStep;
}

export { initiatePrescriptionStep };
